"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SwatchesAndTour() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="243913" id="studiolocation" className="bg-background text-foreground py-24">
      <div ref={ref} className={`container mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="flex flex-col md:flex-row gap-12 items-center">
          {}
          <div className="w-full md:w-1/2 flex flex-col gap-8">
            <div className="overflow-hidden border border-border rounded-xl shadow-lg">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.1975!2d-46.6917!3d-23.5646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDMzJzUyLjYiUyA0NsKwNDEnMzAuMSJX!5e0!3m2!1sen!2sbr!4v1625145000000!5m2!1sen!2sbr" width="100%" height="350" style={{
              border: 0
            }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="w-full h-[350px] object-cover"></iframe>
            </div>
            
            <div className="flex flex-col gap-4">
              <h2 className="text-xl font-bold font-default text-foreground uppercase tracking-wide">
                Localização do Estúdio de Podcast em Pinheiros
              </h2>
              <p className="text-muted-foreground font-default leading-relaxed max-w-md">
                Situado no coração de Pinheiros, próximo à Faria Lima. Nossa estrutura em São Paulo oferece fácil acesso e o ambiente ideal para suas produções audiovisuais.
              </p>
              
              <div className="pt-2 flex flex-wrap gap-4">
                <Button asChild variant="outline" className="rounded-full border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-colors px-8 py-6 text-sm font-semibold uppercase tracking-wider w-fit">
                  <Link to="https://www.google.com/maps/place/23%C2%B033'52.6%22S+46%C2%B041'30.1%22W/@-23.5646,-46.6917,17z" newTab>
                    Abrir no Google Maps
                  </Link>
                </Button>
                <Button asChild variant="default" className="rounded-full bg-primary text-primary-foreground hover:opacity-90 transition-opacity px-8 py-6 text-sm font-semibold uppercase tracking-wider w-fit">
                  <Link to="https://wa.me/5511969100007">
                    Falar no WhatsApp
                  </Link>
                </Button>
              </div>
            </div>
          </div>

          {}
          <div className="w-full md:w-1/2">
            <div className="border border-border p-2 bg-secondary/30 rounded-xl shadow-md">
              <AspectRatio ratio={16 / 9} className="bg-muted overflow-hidden rounded-lg">
                <video className="h-full object-cover !p-0 !m-0 !w-[581.823px]" controls poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/studio_location_view.png" preload="none">
                  <source src="https://www.w3schools.com/html/mov_bbb.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </AspectRatio>
            </div>
          </div>
        </div>
      </div>
    </section>;
}